module.exports = __webpack_public_path__ + "img/澳洲.7eb89236.jpg";